import { DirectiveOptions } from 'vue';

const setFocus = (el:HTMLElement, binding ) => {
	if (binding.value !== undefined && binding.value === false)
		return;

	setTimeout(() => {
		/*
			Priority :
				.focus attribute
				el in focusSelectors
				el child has aria-role "selected"
				el child in focusSelectors

				if .focus is found in el nodes, that will become the new focus parent.
		 */

		const focusSelectors = ['a', 'button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
		let focusObj: HTMLElement = null;
		let focusParent: HTMLElement = el;

		let checkForFocus = el.querySelectorAll(".focus");

		if (checkForFocus.length) {
			focusParent = checkForFocus[0] as HTMLElement;
		}

		if (focusSelectors.includes(focusParent.nodeName.toLowerCase()))
		{
			focusObj = focusParent;
		} else {
			checkForFocus = focusParent.querySelectorAll("[aria-selected='true']");
			if (checkForFocus.length) {
				focusObj = checkForFocus[0] as HTMLElement;
			} else {
				checkForFocus = focusParent.querySelectorAll(focusSelectors.join(","));
				if (checkForFocus.length > 0)
					focusObj = checkForFocus[0] as HTMLElement;
			}
		}

		if (focusObj !== null)
				focusObj.focus();

	}, 300);
}

const directive: DirectiveOptions = {
	inserted: setFocus
};

export default directive;